import { useLocalStorage } from '../../../utils/useLocalStorage';

export const useRequestAnalysisSubmissionQueue = () => {
  const [submissionQueue = [], updateSubmissionQueue] = useLocalStorage('requestAnalysisSubmissionQueue', []);

  return {
    submissionQueue,
    updateSubmissionQueue,
  };
};
